import React from 'react'
import {Container} from 'components/common'
import {FullSvg, Wrapper} from './styles'


const Divider2 = ()=>{
    return(
        <Wrapper as ={Container} >
       <FullSvg/>
                
        </Wrapper>
    )

}

export default Divider2